import { useNavigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { AuthContext } from "../contexts/AuthContext";
import axiosInstance from "../utils/axiosInstance";
import { useRef } from "react";
import { IoPerson } from "react-icons/io5";
import axios from "axios";

const RegisterPharm = () => {
  const url =
    "https://plus.unsplash.com/premium_photo-1661398463833-ea3c24584578?q=80&w=1471&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
  const url1 =
    "https://images.unsplash.com/photo-1576091358783-a212ec293ff3?q=80&w=1450&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

  const [currentImage, setCurrentImage] = useState(url);
  const navigate = useNavigate();

  const inputRef = useRef();

  const handleImageClick = () => {
    inputRef.current.click();
  };

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [lastName, setLastName] = useState("");
  const [licenseNumber, setLicenseNumber] = useState("");
  const [licenseExpiryDate, setLicenseExpiryDate] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(null);

  const notify = (msg) => toast(msg);
  const { setUserData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevImage) => (prevImage === url ? url1 : url));
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleImageUpload = async (e) => {
    const image = e.target.files[0];
    if (!image) {
      notify("No file selected");
      return;
    }

    const formData = new FormData();
    formData.append("media", image);

    try {
      const response = await axios.post(
        "https://pharm-k65v.onrender.com/api/v1/upload",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      const imageUrl = response.data.url; // Assume your server response includes the URL
      setProfilePhoto(imageUrl); // Store the image URL
    } catch (error) {
      console.error(
        "Error uploading image:",
        error.response ? error.response.data : error.message
      );
      notify("Error uploading image");
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!profilePhoto) {
      notify("Please upload a profile photo");
      return;
    }

    if (
      !email ||
      !password ||
      !name ||
      !lastName ||
      !address ||
      !phoneNumber ||
      !licenseNumber ||
      !licenseExpiryDate
    ) {
      notify("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);

      const res = await axiosInstance.post("/auth/create-account/pharmacist", {
        firstName: name,
        lastName,
        phoneNumber,
        email,
        password,
        address,
        licenseNumber,
        licenseExpiryDate,
        imageUrl: profilePhoto, // Use the URL here
      });
      if (res.data.status === "success") {
        notify("Sign Up Successful");
        setUserData(res.data.data);
        setTimeout(() => navigate("/auth/login/pharm"), 3000); // Delay navigation
      } else if (res.data.message === "Pharmacist already exists") {
        notify("User already exists. Please log in.");
        setTimeout(() => navigate("/auth/login/pharm"), 3000); // Delay navigation
      } else {
        notify("Something went wrong. Please try again.");
      }
    } catch (err) {
      if (err.response?.data?.message === "Pharmacist already exists") {
        notify("User already exists. Please log in.");
        setTimeout(() => navigate("/auth/login/pharm"), 3000); // Delay navigation
      } else {
        notify("Sign Up Failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen">
      <div className="flex flex-col md:flex-row h-full">
        {/* Form section */}
        <div className="flex-2 w-full md:w-1/2 bg-white p-8 text-black md:rounded-tl-full border-t-4 md:border-t-0 border-white shadow-lg space-y-4">
          <h1 className="text-3xl md:text-4xl font-bold text-center md:hidden mb-2 text-green-600">
            υγεία
          </h1>
          <form className="mt-2" onSubmit={handleRegister}>
            <h1 className="text-2xl font-bold text-center text-green-600 mb-4">
              Sign Up as a Pharmacist
            </h1>
            <div className="grid grid-cols-2 gap-2 mb-3">
              <div>
                <label htmlFor="fname" className="block font-bold text-sm">
                  First Name:
                </label>
                <input
                  type="text"
                  id="fname"
                  name="fname"
                  required
                  onChange={(e) => setName(e.target.value)}
                  className="w-full p-2 text-black border border-gray-300 rounded-md"
                />
              </div>

              <div>
                <label htmlFor="lname" className="block font-bold text-sm">
                  Last Name:
                </label>
                <input
                  type="text"
                  id="lname"
                  name="lname"
                  required
                  onChange={(e) => setLastName(e.target.value)}
                  className="w-full p-2 text-black border border-gray-300 rounded-md"
                />
              </div>

              <div>
                <label htmlFor="address" className="block font-bold text-sm">
                  Pharmacy Name & Address:
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  required
                  onChange={(e) => setAddress(e.target.value)}
                  className="w-full p-2 text-black border border-gray-300 rounded-md"
                />
              </div>

              <div>
                <label
                  htmlFor="phoneNumber"
                  className="block font-bold text-sm"
                >
                  Phone Number:
                </label>
                <input
                  type="text"
                  id="phoneNumber"
                  name="phoneNumber"
                  required
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="w-full p-2 text-black border border-gray-300 rounded-md"
                />
              </div>

              <div>
                <label
                  htmlFor="licenceNumber"
                  className="block font-bold text-sm"
                >
                  Licence Number:
                </label>
                <input
                  type="text"
                  id="licenceNumber"
                  name="licenceNumber"
                  required
                  onChange={(e) => setLicenseNumber(e.target.value)}
                  className="w-full p-2 text-black border border-gray-300 rounded-md"
                />
              </div>

              <div>
                <label htmlFor="expiryDate" className="block font-bold text-sm">
                  Licence Expiry Date:
                </label>
                <input
                  type="date"
                  id="expiryDate"
                  name="expiryDate"
                  required
                  onChange={(e) => setLicenseExpiryDate(e.target.value)}
                  className="w-full p-2 text-black border border-gray-300 rounded-md"
                />
              </div>
            </div>

            <div className="mb-2">
              <label htmlFor="email" className="block font-bold text-sm">
                Email:
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-2 text-black border border-gray-300 rounded-md"
              />
            </div>

            <div>
              <label htmlFor="password" className="block font-bold text-sm">
                Password:
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full p-2 text-black border border-gray-300 rounded-md"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500"
                >
                  {showPassword ? "Hide" : "Show"}
                </button>
              </div>

              <div className=" mt-2">
                <label
                  htmlFor="profilePhoto"
                  className="block font-bold text-sm"
                >
                  Profile Photo:
                </label>
                <div
                  className="profilePicture cursor-pointer"
                  onClick={handleImageClick}
                >
                  {profilePhoto ? (
                    // If profilePhoto is a URL string, display it directly
                    typeof profilePhoto === "string" ? (
                      <img
                        className="userImage w-20 h-20 object-cover rounded-full border"
                        src={profilePhoto}
                        alt="Profile"
                      />
                    ) : (
                      // If it's a File object, create an object URL
                      <img
                        className="userImage w-20 h-20 object-cover rounded-full border"
                        src={URL.createObjectURL(profilePhoto)}
                        alt="Profile"
                      />
                    )
                  ) : (
                    <div className="userImage w-10 h-10 flex items-center justify-center bg-gray-200 rounded-full border">
                      <IoPerson size={20} className="text-gray-500" />
                    </div>
                  )}
                </div>

                <input
                  type="file"
                  style={{ display: "none" }}
                  ref={inputRef}
                  onChange={handleImageUpload}
                  accept=".jpeg, .jpg, .png, .gif"
                />
              </div>

              <button
                type="submit"
                className="bg-green-600 text-white font-bold py-2 px-4 rounded-md w-full mt-2"
              >
                Sign Up
              </button>

              <h4 className="mt-4   mb-4">
                Already have an account?
                <span
                  onClick={() => navigate("/auth/login/pharm")}
                  className="text-blue-400 hover:underline cursor-pointer ml-2"
                >
                  Log In
                </span>
              </h4>
            </div>
          </form>
        </div>

        {/* Image Container */}
        <div
          className="relative flex-1 w-full h-full hidden md:flex justify-center items-center"
          style={{
            backgroundImage: `url(${currentImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 flex justify-center items-center">
            <span className="text-white text-8xl font-bold drop-shadow-lg">
              υγεία
            </span>
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default RegisterPharm;
